$( document ).ready(function() {

$('#products form').each(function(){
  let product = $(this);

  product.find('.single-option-selector__radio').change(function(){
      let query_selector = 'select.variants-data option';

      if ( product.find('[name=option1]').length > 0 ) {
          query_selector += '[option1="' + product.find('[name=option1]:checked').val() + '"]';
      }

      if ( product.find('[name=option2]').length > 0 ) {
          query_selector += '[option2="' + product.find('[name=option2]:checked').val() + '"]';
      }

      if ( product.find('[name=option3]').length > 0 ) {
          query_selector += '[option3="' + product.find('[name=option3]:checked').val() + '"]';
      }

      let submit_button = product.find('button.add_to_cart_button');
      if ( product.find( query_selector ).text() == 'true' ) {
          product.find('select.variants-data').val( product.find( query_selector ).val() );

          submit_button.css('opacity','1');
          submit_button.css('pointer-events','all');
      } else {
          submit_button.css('opacity','0.3');
          submit_button.css('pointer-events','none');
      }
  })

});

});
